import { BaseContainerModel } from "../../base-container.model";
import { bl_fi_cash_document_line_RowClass,  } from "../../../dbschema";

export class CashDocumentLineContainerModel extends BaseContainerModel {
    bl_fi_cash_document_line: bl_fi_cash_document_line_RowClass = new bl_fi_cash_document_line_RowClass();
}
